var _rect, _text, _text2, _circle, _text3, _text4, _rect2, _text5, _line, _rect3, _text6, _line2, _rect4, _text7, _line3, _rect5, _text8, _line4, _rect6, _text9, _line5, _rect7, _text10, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg05HarnessBlocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 420",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 420,
    fill: "#fafafa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 34,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "Building Blocks of a Harness")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 56,
    textAnchor: "middle",
    fill: "#666",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Agent = Model + everything around it")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 210,
    r: 58,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 2.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 205,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "LLM")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 225,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Model")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 90,
    width: 160,
    height: 56,
    rx: 10,
    fill: "#bfdbfe",
    stroke: "#111",
    strokeWidth: 2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 124,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "Policy / AGENTS.md")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 118,
    x2: 395,
    y2: 180,
    stroke: "#111",
    strokeWidth: 1.6,
    strokeDasharray: "4 3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 90,
    width: 160,
    height: 56,
    rx: 10,
    fill: "#bbf7d0",
    stroke: "#111",
    strokeWidth: 2
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 124,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "Tools + APIs")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 118,
    x2: 505,
    y2: 180,
    stroke: "#111",
    strokeWidth: 1.6,
    strokeDasharray: "4 3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 200,
    width: 160,
    height: 56,
    rx: 10,
    fill: "#fce7f3",
    stroke: "#111",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 234,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "Memory systems")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 228,
    x2: 392,
    y2: 210,
    stroke: "#111",
    strokeWidth: 1.6,
    strokeDasharray: "4 3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 200,
    width: 160,
    height: 56,
    rx: 10,
    fill: "#fef3c7",
    stroke: "#111",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 234,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "Validation")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 700,
    y1: 228,
    x2: 508,
    y2: 210,
    stroke: "#111",
    strokeWidth: 1.6,
    strokeDasharray: "4 3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 320,
    width: 160,
    height: 56,
    rx: 10,
    fill: "#e0e7ff",
    stroke: "#111",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 354,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "Orchestration")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 340,
    x2: 400,
    y2: 255,
    stroke: "#111",
    strokeWidth: 1.6,
    strokeDasharray: "4 3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 670,
    y: 320,
    width: 160,
    height: 56,
    rx: 10,
    fill: "#e5e7eb",
    stroke: "#111",
    strokeWidth: 2
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 354,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 600
  }, "Monitoring")), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 340,
    x2: 500,
    y2: 255,
    stroke: "#111",
    strokeWidth: 1.6,
    strokeDasharray: "4 3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg05HarnessBlocks);
export default __webpack_public_path__ + "static/media/05-harness-blocks.979e9d85ee5ef4db87a3e32b1e156b52.svg";
export { ForwardRef as ReactComponent };